<template>
  <span
    :style="combinedStyle"
    @click="$emit('click', $event.target ? $event.target.value : false)"
    @keydown="$emit('click', $event.target ? $event.target.value : false)"
  ><slot /></span>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            default: null,
        },
        underline: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        colorStyle() {
            if (this.color) {
                return `color: ${this.color};`;
            }
            return '';
        },
        underlineStyle() {
            if (this.underline) {
                return 'text-decoration: underline;';
            }
            return '';
        },
        combinedStyle() {
            const defaultStyle = 'cursor: pointer;';
            return `${defaultStyle} ${this.underlineStyle} ${this.colorStyle}`;
        },
    },
};
</script>
